// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3dlKX","dragIcon":"Choice_dragIcon__2Eapv","left":"Choice_left__1jY_G","input":"Choice_input__3C14p"};